var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ShieldCheck component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShieldCheck extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.0395 22.5132C11.3263 22.6088 11.6132 22.7044 11.9 22.7044H11.9C12.1869 22.7044 12.4737 22.7044 12.7605 22.6088C15.7246 21.4614 18.2105 19.4535 20.0272 16.8719C21.8439 14.1947 22.8 11.1351 22.8 7.97983V3.29474C22.8 2.62544 22.5132 2.05175 22.1307 1.6693C21.6526 1.19123 21.0789 1 20.5053 1H3.29474C2.62544 1 2.05175 1.28684 1.6693 1.6693C1.19123 2.14737 1 2.72105 1 3.29474V7.88421C1 11.1351 1.95614 14.1947 3.77281 16.7763C5.58947 19.3579 8.07544 21.3658 11.0395 22.5132ZM2.72105 2.81667C2.81667 2.62544 3.10351 2.52982 3.29474 2.52982V2.43421H20.4096C20.6009 2.43421 20.7921 2.52982 20.9833 2.72105C21.1746 2.81667 21.2702 3.10351 21.2702 3.29474V7.97983C21.2702 10.8482 20.4096 13.6211 18.7842 16.0114C17.1588 18.4018 14.864 20.2184 12.1868 21.2702C11.9956 21.3658 11.8044 21.3658 11.6132 21.2702C8.93596 20.2184 6.64123 18.4018 5.01579 16.0114C3.39035 13.6211 2.52982 10.8482 2.52982 7.97983V3.29474C2.52982 3.10351 2.52982 2.91228 2.72105 2.81667ZM9.98755 14.7682C10.0832 14.9594 10.1788 14.9594 10.37 14.9594C10.5612 14.9594 10.7525 14.8638 10.8481 14.7682L17.3498 7.59714C17.5411 7.21468 17.5411 6.83223 17.2542 6.54538C16.9674 6.35416 16.4893 6.35416 16.2025 6.641L10.37 13.2384L7.78842 11.2305C7.40597 10.9436 6.9279 11.0392 6.73667 11.3261C6.44983 11.7085 6.54544 12.1866 6.83228 12.3778L9.98755 14.7682Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShieldCheck.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldCheck.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldCheck.prototype, "size", void 0);
if (customElements.get('cat-icon-shield-check') === undefined) {
    customElements.define('cat-icon-shield-check', BlocksIconShieldCheck);
}
